import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/integrations/webhooks')({
  component: WebhooksLayout,
});

function WebhooksLayout() {
  return <Outlet />;
}
